/* eslint-disable no-loop-func */
import { React } from 'react';
import { useMakeReportPricing } from '~/unit-types';
import { useMeasurements } from '~/measurements';
import { } from '~/entrataReports';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Dayjs from 'dayjs';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


const UnitTypesPricing = props => {

    const {
        data, isLoading, isFetching, isError
    } = useMakeReportPricing(props.match.params.property_id);

    const {
        data: measurements
    } = useMeasurements(props.match.params.property_id);


    if (isLoading || isFetching) {

        return (
            <Box sx={{
                display: 'flex',
                marginLeft: '48%',
                marginTop: '200px'
            }}>
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return 'Internal Error - Contact Technical Support';
    }

    function getUniqueListBy(arr, key) {
        return [...new Map(arr.map(item => [item[key], item])).values()];
    }

    const distinct_date = getUniqueListBy(measurements, 'created_at');

    const GetRows = (measurements, distinct_date) => {

        const rows = [];
        let cell_row = [];

        for (let j = 0; j < distinct_date.length; j++) {

            let cells = { };
            const date_created_at = distinct_date[j].created_at;

            (data.allUnitTypesWithRate || []).map((unit_type, i) => {
                const measurement = measurements.filter(x => (x.created_at === date_created_at && x.unit_type_id === unit_type.id));

                cells = {
                    name: measurement[0].name,
                    growth_rate: measurement[0].growth_value,
                    base_price: measurement[0].base_price,
                    date: measurement[0].date,
                    date_created_at: Dayjs(date_created_at).format('MM/DD/YYYY h:mm:ss A')
                };
                cell_row.push(cells);
                cells = {};

                return cells;

            });
            rows.push(cell_row);
            cell_row = [];

        };

        return rows;

    };

    const new_price = measurement => {
        const daysSinceLastPriceUpdate = Dayjs().diff(measurement.date, 'days');

        return Math.round((measurement.base_price * measurement.growth_rate) * (daysSinceLastPriceUpdate / 365) + measurement.base_price) || 0;

    };


    return (
        <div>
            <div>
                <TableContainer component={Paper}>
                    <Table sx={{
                        minWidth: 650,
                        border: 'solid 1px blue',
                        borderBottom: 'solid 1.1px blue',
                        fontWeight: 'bold',
                        marginBottom: '5px'
                    }} size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}> Property: {data.property_name.toUpperCase()}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}> NUMBER OF UNITS: {data.total_units}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>MARKET RENT</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>YEAR BUILD: {data.year_built}</TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
            </div>
            <div>
                <TableContainer component={Paper}>
                    <Table sx={{
                        minWidth: 650,
                        border: 'solid 1px black',
                        borderBottom: 'solid 1.1px black',
                        fontWeight: 'bold'

                    }} size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{
                                    fontWeight: 'bold',
                                    border: 'solid 1px black'
                                }}>MO/YR</TableCell>
                                {(data.allUnitTypesWithRate || []).map((unit_type, i) => (
                                    <TableCell sx={{
                                        fontWeight: 'bold',
                                        border: 'solid 1px black'
                                    }}> {unit_type.name.toUpperCase()}  </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}></TableCell>
                                {(data.allUnitTypesWithRate || []).map((unit_type, i) => (
                                    <TableCell sx={{
                                        fontWeight: 'bold',
                                        border: 'solid 1px black'
                                    }}> {unit_type.sq_footage} sq ft </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{
                                    fontWeight: 'bold',
                                    borderBottom: 'solid 1.1px black'
                                }}></TableCell>
                                {(data.allUnitTypesWithRate || []).map((unit_type, i) => (
                                    <TableCell sx={{
                                        fontWeight: 'bold',
                                        border: 'solid 1px black',
                                        borderBottom: 'solid 1.1px black'
                                    }}> {unit_type.total_units} units </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {GetRows(measurements, distinct_date).map(x => (

                                <>
                                    <TableRow>
                                        <TableCell sx={{ color: 'green' }}> {x[0].date_created_at} </TableCell>
                                        {x.map(t => {
                                            const color_style = (t.growth_rate === 0) ? 'red' : 'green';

                                            return (<TableCell sx={{ color: color_style }}> {(t.growth_rate * 100).toFixed(2)}% </TableCell>);
                                        })}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell> {x[0].date_created_at} </TableCell>
                                        {x.map(t => {
                                            const color_style = (t.growth_rate === 0) ? 'red' : 'black';

                                            return (<TableCell sx={{ color: color_style }}> {new_price(t)} </TableCell>);
                                        })}
                                    </TableRow>
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
};

export default UnitTypesPricing;
